import { render, staticRenderFns } from "./ScreenLaudoPerfilCervical.vue?vue&type=template&id=24f8ad6c&lang=true&"
import script from "./ScreenLaudoPerfilCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoPerfilCervical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports